var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mine-page"},[_c('div',{staticClass:"header"},[_c('UserCard',{attrs:{"role":_vm.USER_ROLES.REGION_MANAGER,"user":_vm.user,"store":_vm.currentStore}})],1),_c('div',[_c('CCell',{attrs:{"title":"区域","value":_vm.user.regionName}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }